import React from "react"
import { useNavigate } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { isEqual } from "lodash";

import 'react-tabs/style/react-tabs.css';

import * as PD from '../classes/pdStyle';
import {getParam} from '../utils/utils';

import Buffering from "../components/Buffering";
import Rendition from '../components/Rendition';
import ViewMetadata from "../components/ViewMetadata";
import ViewItem from "../components/ViewItem";
import TreeCodeList from "../components/TreeCodeList";

import dsd from "../classes/clsDSD";

import { DesignerLayoutContext } from '../contexts/DesignerLayoutContext';

import {getCodeList, getItem, addItemToCodeList, editItem} from '../utils/utilsCodeList';
import ParentItemRow from '../components/ParentItemRow';


class Item extends React.Component {

    static contextType = DesignerLayoutContext;

    constructor(props) {
        super(props);
        this.state = {
            mode: 'view',
            renderState: null,
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleMode   = this.handleMode.bind(this);

        this.addParent    = this.addParent.bind(this);
        this.removeParent = this.removeParent.bind(this);
        this.updateParent = this.updateParent.bind(this);
        this.loadedChildren = this.loadedChildren.bind(this);

        this.dsd = new dsd();
        this.dsd.StateObject = this;

        this.FallBackNavigation = `/codelists`;
    }

    componentDidMount() { this.setup(); }

    componentDidUpdate(prevProps) {
        if (!isEqual(this.props, prevProps)) { this.setup(); }
    }

    loadCodeList(id) {

        if (!id) { return; }

        const onLoad = function(data) {
            this.setState({ CodeList: data, renderState: 'loaded' });
            if (this.context.hasLayout){
                this.context.Layout.setLeftAsCodeList(data._id);
            }
        }.bind(this);

        const onFail = function(e) {
            this.setState({ renderState: 'failed', errorMessage: e.message });
        }.bind(this);

        getCodeList(this.dsd, id, onLoad, onFail);
    }

    loadItem(id) {

        if (!id) { return; }

        this.setState({ renderState: 'loading' });

        const onLoad = function(data) {

            let StateChange = {};
            StateChange.Item = data;
            StateChange.FormData = data;
            StateChange.renderState = 'loaded';

            StateChange.OfferEdit = false;
            try {
                if (this.dsd.loggedon) {
                    if (data.CodeList && data.CodeList.idUser == this.dsd.user.id) {
                        StateChange.OfferEdit = true;
                    }
                }
            } catch(e) {}

            if (!StateChange.OfferEdit) {
                switch (this.state.mode) {
                    case 'edit':
                    case 'remove':
                        StateChange.renderState = 'denied';
                        StateChange.errorMessage = 'You cannot edit this Item';
                        break;
                }
            }

            if (data.CodeList) {
                StateChange.CodeList = data.CodeList;
                this.FallBackNavigation = `/codelist/${data.CodeList._id}`;
            }

            this.setState(StateChange, () => {
                if (this.context.hasLayout && data.CodeList){
                    this.context.Layout.setLeftAsCodeList(data.CodeList._id);
                }
            });

        }.bind(this);

        const onFail = function(e) {
            let StateChange = {};
            StateChange.renderState = 'failed';
            StateChange.errorMessage = e.message;
            if (e.response && e.response.status === 403) {
                StateChange.renderState = 'denied';
                StateChange.errorMessage = 'Access Denied';
            }
            this.setState(StateChange);
        }.bind(this);

        getItem(this.dsd, id, onLoad, onFail);
    }

    setup() {

        let StateChange = {
            mode: 'view',
            idItem: null,
            idCodeList: null,
            CodeList: null,
            Item: null,
            isUpdated: false,
            isFailed: false,
            errorMessage: null,
            renderState: null,
            FormData: {},
            OfferEdit: false,
            fallbackpath: null,
            countChildren: null,
        };

        if (this.props.location && this.props.location.state) {
            if (this.props.location.state.fallbackpath) {
                StateChange.fallbackpath = this.props.location.state.fallbackpath;
            }
        }

        if (getParam('mode', this.props)) {
            StateChange.mode = getParam('mode', this.props);
        }

        StateChange.idItem = getParam('id', this.props);
        StateChange.idCodeList = getParam('idCodeList', this.props);

        switch (StateChange.mode) {
            case 'new':
                if (!StateChange.idCodeList) {
                    StateChange.renderState = 'invalid';
                    StateChange.errorMessage = 'Code List not specified when adding an Item';
                } else {
                    StateChange.FormData = { status: 'in use' };
                }
                break;
            default:
                if (!StateChange.idItem) {
                    StateChange.renderState = 'invalid';
                    StateChange.errorMessage = 'Item not specified';
                }
                break;
        }

        if (StateChange.mode === 'new' && StateChange.idCodeList) {
            this.FallBackNavigation = `/codelist/${StateChange.idCodeList}`;
        }

        this.setState(StateChange, () => {
            if (this.state.idCodeList) {
                this.loadCodeList(this.state.idCodeList);
            }
            if (this.state.idItem) {
                this.loadItem(this.state.idItem);
            }
        });
    }

    handleChange(event) {

        const FormFieldName = event.target.name;
        let FormFieldValue = event.target.value;

        if (event.target.type === 'checkbox') {
            FormFieldValue = event.target.checked;
        }

        let FormData = this.state.FormData;
        FormData[FormFieldName] = FormFieldValue;
        this.setState({ FormData: FormData });
    };

    handleSubmit(event) {

        window.scrollTo(0, 0);

        switch (event.target.name) {

            case 'btnCancel':
                switch (this.state.mode) {
                    case 'new':
                        if (this.state.fallbackpath) {
                            this.props.navigation(this.state.fallbackpath);
                        } else {
                            this.props.navigation(this.FallBackNavigation);
                        }
                        break;
                    case 'edit':
                        this.props.navigation(`/item/${this.state.idItem}`);
                        break;
                    default:
                        break;
                }
                break;

            case 'btnSave':
            default:

                this.setState({ isUpdated: false, isFailed: false, invalidFields: false, renderState: 'updating' });

                const onError = function(e) {
                    let StateChange = { renderState: 'error' };
                    StateChange.errorMessage = e.message;
                    if (e.response && e.response.data) {
                        if (e.response.data.message) {
                            StateChange.errorMessage = e.response.data.message;
                        }
                        if (e.response.data.fields) {
                            StateChange.invalidFields = e.response.data.fields;
                        }
                    }
                    this.setState(StateChange);
                }.bind(this);

                switch (this.state.mode) {
                    case 'new':
                        const onAdd = function(id) {
                            this.props.navigation(`/item/${id}`);
                        }.bind(this);
                        addItemToCodeList(this.dsd, this.state.idCodeList, this.state.FormData, onAdd, onError);
                        break;
                    case 'edit':
                        const onUpdate = function() {
                            this.props.navigation(`/item/${this.state.idItem}`);
                        }.bind(this);
                        editItem(this.dsd, this.state.idItem, this.state.FormData, onUpdate, onError);
                        break;
                    default:
                        break;
                }
        }

        event.preventDefault();
    }

    addParent(){
        let FormData = {...this.state.FormData};
        FormData.Parents = [...(FormData.Parents || []), {}];
        this.setState({FormData: FormData});
    }

    removeParent(seq){
        let FormData = {...this.state.FormData};
        FormData.Parents = [...(FormData.Parents || [])];
        FormData.Parents.splice(seq - 1, 1);
        this.setState({FormData: FormData});
    }

    updateParent(seq, Parent){
        let FormData = {...this.state.FormData};
        FormData.Parents = [...(FormData.Parents || [])];
        FormData.Parents[seq - 1] = Parent;
        this.setState({FormData: FormData});
    }

    loadedChildren(count) {
        this.setState({ countChildren: count || 0 });
    }

    showError(){
        return (
            <>
                {this.state.errorMessage &&
                    <p>{this.state.errorMessage}</p>
                }
                {this.state.invalidFields &&
                    Object.keys(this.state.invalidFields).map(
                        (field, pos) => {
                            let error = this.state.invalidFields[field].error;
                            return <p key={pos}>{field}: {error}</p>;
                        }
                    )
                }
            </>
        );
    }

    handleMode(event) {
        this.setState({ mode: event.target.value });
        event.preventDefault();
    }

    render() {

        switch (this.state.renderState) {
            case 'invalid':
            case 'failed':
            case 'denied':
                let Message = 'An error has occured';
                if (this.state.errorMessage) { Message = this.state.errorMessage; }
                return <PD.ErrorBox>{Message}</PD.ErrorBox>;
            case 'loading':
                return <Buffering/>;
        }

        switch (this.state.mode) {
            case 'new':
            case 'edit':

                switch (this.state.renderState) {
                    case 'loaded':
                    case 'updating':
                    case 'error':
                        return (
                            <div>
                                <PD.Heading>{this.state.mode} Item</PD.Heading>

                                {this.state.renderState === 'error' &&
                                    <PD.ErrorBox>{this.showError()}</PD.ErrorBox>
                                }

                                {this.state.CodeList &&
                                    <div><strong>Code List:</strong> {this.state.CodeList.name}</div>
                                }

                                <form>
                                    <PD.Input label="Code" width="20" maxLength="20" name="code" value={this.state.FormData.code} onChange={this.handleChange}/>

                                    <PD.Input label="Label" width="60" name="label" value={this.state.FormData.label} onChange={this.handleChange}/>

                                    <PD.Editor label='Definition' name="definition" value={this.state.FormData.definition} onChange={this.handleChange}/>

                                    <PD.Editor label='Usage Notes' name="usageNotes" value={this.state.FormData.usageNotes} onChange={this.handleChange}/>

                                    <PD.Select label="Status" name='status' onChange={this.handleChange} value={this.state.FormData.status}>
                                        {
                                            this.dsd.config.ItemStatuses.map(
                                                (status, posStatus) =>
                                                    {
                                                        return(
                                                            <option key={posStatus} value={status}>{status}</option>
                                                        )
                                                    }
                                            )
                                        }
                                    </PD.Select>

                                    {this.FormParents()}

                                    {(() => {
                                        switch (this.state.renderState) {
                                            case 'updating':
                                                return (
                                                    <div>
                                                        <PD.Button disabled={true} type="submit" name="btnSave">
                                                            <Buffering/>
                                                        </PD.Button>
                                                    </div>
                                                );
                                            default:
                                                return (
                                                    <div>
                                                        <PD.Button type="submit" onClick={this.handleSubmit} name="btnSave" value="Save" />
                                                        <PD.Button type="warning" onClick={this.handleSubmit} name="btnCancel" value="Cancel" />
                                                    </div>
                                                );
                                        }
                                    })()}

                                </form>
                            </div>
                        );
                }
                break;

            case 'view':
            default:

                switch (this.state.renderState) {
                    case 'loaded':
                        return (
                            <div>
                                <PD.Heading>Item: {this.state.Item.code}</PD.Heading>

                                {this.state.OfferEdit &&
                                    <span style={{paddingRight:10}}>
                                        <PD.Button onClick={this.handleMode} type="submit" value="edit" />
                                    </span>
                                }

                                <ViewItem Item={this.state.Item}/>

                                <br/>

                                <PD.Tabs>

                                    <div label='Code List'>
                                        {this.state.CodeList &&
                                            <PD.Table>
                                                <PD.Tbody>
                                                    <PD.Tr>
                                                        <PD.Th>Name</PD.Th>
                                                        <PD.Td>
                                                            <PD.PdNavLink to={`/codelist/${this.state.CodeList._id}`}>{this.state.CodeList.name}</PD.PdNavLink>
                                                        </PD.Td>
                                                    </PD.Tr>
                                                    {this.state.CodeList.description &&
                                                        <PD.Tr>
                                                            <PD.Th>Description</PD.Th>
                                                            <PD.Td>
                                                                <PD.MdPresent>{this.state.CodeList.description}</PD.MdPresent>
                                                            </PD.Td>
                                                        </PD.Tr>
                                                    }
                                                </PD.Tbody>
                                            </PD.Table>
                                        }
                                    </div>

                                    <div label={`Parents(${this.state.Item.Parents ? this.state.Item.Parents.length : 0})`}>
                                        {this.state.Item.Parents && this.state.Item.Parents.length > 0 &&
                                            <PD.Table className="list">
                                                <PD.Thead>
                                                    <PD.Tr>
                                                        <PD.Th>Code</PD.Th>
                                                        <PD.Th>Label</PD.Th>
                                                        <PD.Th>Parents</PD.Th>
                                                    </PD.Tr>
                                                </PD.Thead>
                                                <PD.Tbody>
                                                    {this.state.Item.Parents.map((parent, pos) => (
                                                        <PD.Tr key={pos}>
                                                            <PD.Td>
                                                                {parent.ParentItem
                                                                    ? <PD.PdNavLink to={`/item/${parent.ParentItem._id}`}>{parent.ParentItem.code}</PD.PdNavLink>
                                                                    : String(parent.idParent)
                                                                }
                                                            </PD.Td>
                                                            <PD.Td>{parent.ParentItem && parent.ParentItem.label}</PD.Td>
                                                            <PD.Td>
                                                                {parent.ParentItem && parent.ParentItem.Parents && parent.ParentItem.Parents.map((gp, gppos) => (
                                                                    gp.ParentItem &&
                                                                    <div key={gppos}>
                                                                        <PD.PdNavLink to={`/item/${gp.ParentItem._id}`}>{gp.ParentItem.code}</PD.PdNavLink>
                                                                    </div>
                                                                ))}
                                                            </PD.Td>
                                                        </PD.Tr>
                                                    ))}
                                                </PD.Tbody>
                                            </PD.Table>
                                        }
                                    </div>

                                    <div label={<span>Children({this.state.countChildren === null ? <Buffering/> : this.state.countChildren})</span>} data-forcerender="true">
                                        <TreeCodeList
                                            idCodeList={this.state.CodeList ? String(this.state.CodeList._id) : this.state.idCodeList}
                                            idItem={this.state.Item ? String(this.state.Item._id) : null}
                                            onLoad={this.loadedChildren}
                                        />
                                    </div>

                                    <div label='Metadata'>
                                        <ViewMetadata Data={this.state.Item} />
                                    </div>

                                    <div label='Developer'>
                                        <Rendition
                                            endpoint="/items"
                                            id={this.state.idItem}
                                        />
                                    </div>

                                </PD.Tabs>

                            </div>
                        );
                }
        }

        return <div />;
    };


    FormParents(){

        const idCodeList = this.state.CodeList ? String(this.state.CodeList._id) : this.state.idCodeList;

        let seqNext = 1;
        if (this.state.FormData.Parents){
            seqNext = this.state.FormData.Parents.length + 1;
        }
        return (
            <fieldset>
                <legend>Parents</legend>
                <PD.Table type="list">
                    {this.state.FormData.Parents &&
                        this.state.FormData.Parents.map(
                            (Parent, posParent) => {
                                let seq = posParent + 1;
                                return this.FormParent('edit', seq, Parent, idCodeList);
                            }
                        )
                    }
                    {this.FormParent('new', seqNext, {}, idCodeList)}
                </PD.Table>
            </fieldset>
        );
    }

    FormParent(mode, seq, Parent = {}, idCodeList){
        return (
            <ParentItemRow
                key={seq.toString()}
                mode={mode}
                onAdd={this.addParent}
                onRemove={this.removeParent}
                onUpdate={this.updateParent}
                Parent={Parent}
                seq={seq}
                idCodeList={idCodeList}
            />
        );
    }

}

export default function Item_wrapper(props) {
    const navigation = useNavigate();
    const location   = useLocation();
    const params     = useParams();
    return <Item {...props} navigation={navigation} location={location} params={params} />;
}
